import React from "react";
import { useLocation, Link } from "react-router-dom";
import BannerImage from "../../assets/images/gallery/g1.jpg";
import "./banner1.css";

const Banner1 = () => {
  const location = useLocation();

  const pageNames = {
    "/about-us": { page: "About", banner: "Discover About Us" },
    "/gallery": { page: "Gallery", banner: "Our Beautiful Gallery" },
    "/tours": { page: "Tours", banner: "Explore Our Tours" },
    "/contact-us": { page: "Contact Us", banner: "Get in Touch" },

    // 🔹 Newly added
    "/privacy-policy": { page: "Privacy Policy", banner: "Our Privacy Policy" },
    "/terms-and-conditions": { page: "Terms & Conditions", banner: "Terms & Conditions" },
  };

  const pageData = pageNames[location.pathname] || { page: "Page", banner: "Welcome to Our Website" };

  return (
    <div className="banner-container">
      <img src={BannerImage} alt="Banner" className="banner-image" />
      <div className="banner-text">
        <h2 className="banner-title">{pageData.banner}</h2>
        <small className="breadcrumb">
          <Link to="/" className="home-link">Home</Link> &nbsp;/&nbsp;
          <span className="current-page">{pageData.page}</span>
        </small>
      </div>
    </div>
  );
};

export default Banner1;
